import { jsPDF } from 'jspdf';
import Papa from 'papaparse';
import { addBrandFooterToCanvas, applyBrandedPdfChrome } from '../../branding/exportBranding';

export const exportRootCauseChartAsPNG = () => {
    const chart = document.getElementById('chartjs-chart');
    const canvas = chart?.querySelector('canvas');
    if (!canvas) return;

    const brandedCanvas = addBrandFooterToCanvas(canvas);
    const image = brandedCanvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const link = document.createElement('a');
    link.href = image;
    link.download = 'root-cause-chart.png';
    link.click();
};

export const exportRootCausePDF = (groupedByProbability) => {
    const doc = new jsPDF();
    doc.text('Root Cause Analysis - Evidence Scores', 10, 10);
    let yOffset = 20;

    Object.keys(groupedByProbability).forEach((probability) => {
        doc.text(`Evidence score bucket: ${probability}`, 10, yOffset);
        yOffset += 10;
        groupedByProbability[probability].forEach((step) => {
            doc.text(`Step ${step.relatedStep}: ${step.rootCauseScore ?? step.probability} score`, 20, yOffset);
            yOffset += 10;
        });
        yOffset += 10;
    });

    applyBrandedPdfChrome(doc, { title: 'Root Cause Analysis - Evidence Scores' });
    doc.save('root-cause-probabilities.pdf');
};

export const exportRootCauseCSV = (groupedByProbability) => {
    const data = [];

    Object.keys(groupedByProbability).forEach((probability) => {
        groupedByProbability[probability].forEach((step) => {
            data.push({
                Probability: `${probability}%`,
                Step: `Step ${step.relatedStep}`,
                Score: step.rootCauseScore ?? step.probability,
                CaseFailRate: step.caseFailRate,
                ControlFailRate: step.controlFailRate,
                OddsRatio: step.oddsRatio,
            });
        });
    });

    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'root-cause-probabilities.csv';
    link.click();
    URL.revokeObjectURL(link.href);
};
